<template>
  <div class="main1">
    <div class="content1">
      <div>
        <h3 class="payment-notice">{{ payment_notice }}</h3>
        <p>请选择缴费年限</p>
        <div class="card_box">
          <div v-for="(item, index) in member_payment_years" :key="index" @click="change_buy_num(item)">
            <div v-if="buy_num==item.value" class="cardSelected">
              <div style="margin: auto 20px;">
                {{ item.name }}
              </div>
              <div style="position: absolute;bottom: 0;right: 0; width: 30px;
       height: 30px;
        background: #E40080;
        clip-path: polygon(100% 0, 0 100%, 100% 100%);">
                <img width="100%" src="../assets/answer.png" alt="" style="position: absolute;
    right: 4px;
    bottom: 4px;
    width: 11px;">
              </div>
            </div>
            <div v-else class="card">
              <div style="margin: auto 20px;">
                {{ item.name }}
              </div>
            </div>

          </div>

        </div>
      </div>
      <div class="payment">

        <div class="payment-information flex">
          <p>订单信息</p>
          <div>
            <div class="flex">
              <p>订单名称：</p>
              <p>{{ orderName }}</p>
            </div>
<!--            <div class="flex">-->
<!--              <p>订单金额：</p>-->
<!--              <p>￥{{ orderAmount }}</p>-->
<!--            </div>-->
          </div>
        </div>
        <div class="payment-price flex">
          <p>支付金额</p>
          <div>￥{{ Number((Number(orderAmount) * Number(buy_num)).toFixed(2)) }}</div>
        </div>
      </div>

      <div class=" flex invoice_box">
        <div>
          <el-form  :model="applyFor_form" :rules="applyFor_form_rules" ref="applyFor_form_ref"  label-position="top">
            <div class="flex_between" style="margin-bottom: 10px">
              <el-button style="float: right;" type="primary" @click="toAdd()">添加发票抬头</el-button>
<!--                            <el-button style="float: right;" type="primary" @click="applyForSubmit()">申请发票-->
<!--                            </el-button>-->
            </div>
            <el-form-item label="发票抬头选择" prop="invoice_id">
              <el-select v-model="applyFor_form.invoice_id" placeholder="请选择发票"
                         @change="invoiceChange(applyFor_form.invoice_id)">
                <el-option
                    v-for="item in invoiceList"
                    :key="item.id"
                    :label="item.header"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

          </el-form>
        </div>
        <div class="box_right">
          <div class="flex">
            <p>发票类型：</p>
            <p>{{reverse_display(headerForm_web.invoice_type,typeOptions)}}</p>
          </div>
          <div class="flex">
            <p>抬头类型：</p>
            <p>{{ reverse_display(headerForm_web.header_type,headerOptions)}}</p>
          </div>
          <div class="flex">
            <p>发票抬头名称：</p>
            <p>{{ headerForm_web.header }}</p>
          </div>
          <div class="flex">
            <p>纳税人识别号：</p>
            <p>{{ headerForm_web.identification_code }}</p>
          </div>
          <div class="flex">
            <p>邮箱：</p>
            <p>{{ headerForm_web.email }}</p>
          </div>
        </div>
      </div>

      <button class="pay" @click="handleShowPaymentOnline">去支付</button>
      <el-dialog
          :visible.sync="showPaymentOnline"
          width="900px"
          class="paymentOnlineDialog"
          :close-on-click-modal="false"
          custom-class="payment-dialog"
          :append-to-body="true"
          top="15vh"
      >
        <p>订单信息</p>
        <div class="paymentOnlineDialog-infomation">
          <div>
            <div class="flex">
              <p>订单号：</p>
              <p>{{ orderNumber }}</p>
            </div>
            <div class="flex">
              <p>订单名称：</p>
              <p>{{ orderName }}</p>
            </div>
<!--            <div class="flex">-->
<!--              <p>订单金额：</p>-->
<!--              <p style="color: #FF4D4F">￥{{ Number((Number(orderAmount) * Number(buy_num)).toFixed(2)) }}</p>-->
<!--            </div>-->
            <div class="flex">
              <p>订单时间：</p>
              <p>{{ createOrderTime }}</p>
            </div>
          </div>

        </div>
        <p>支付方式</p>
        <div class="paymentOnlineDialog-method flex" v-loading="paymentLoading">
          <div class="left flex">
            <div class="paymentOnlinceDialog-QRCode"
                 v-loading="QRCodeLoading"
                 element-loading-text="加载中"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0, 0, 0, 0.8)">
              <span v-if="payMethod != 2 && payMethod !== 3"></span>
              <img v-if="payMethod == 2 && QRCodeSrc !== ''" :src="QRCodeSrc" alt="">
              <iframe
                  v-if="payMethod == 3 && aliPayForm != ''"
                  :srcdoc="aliPayForm"
                  frameborder="no"
                  border="0"
                  marginwidth="0"
                  marginheight="0"
                  scrolling="no"
                  width="120"
                  height="120"
                  style="overflow: hidden"
              >
              </iframe>
            </div>
            <div>
              <p class="parmentOnlineDialog-title">在线支付</p>
              <div class="flex">
                <div v-for="(item, index) in paymentInfo" :key="index"
                     :class="['paymentOnlineDialog-channel', 'flex', payMethod == item.pay_config_id ? 'selected' : '']"
                     @click="handleSelectPayMethod(item.pay_config_id)">
                  <img :src="item.icon" alt="">
                  <div>{{ item.pay_way_name }}</div>
                </div>
              </div>
              <button class="paymentOnlineDialog-paidAlready" @click="handlePaidAlready">我已缴费</button>
            </div>
          </div>
          <div class="right">
            <div class="flex">
              <div class="paymentOnlineDialog-icon">￥</div>
              <p>对公转账</p>
            </div>
            <div class="paymentOnlineDialog-tips">选择对公转账方式后，订单有效期30天，请尽快完成转账</div>
            <button @click="handleShowCorporateTransfer">我要对公转账</button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
          :visible.sync="showCorporateTransfer"
          width="825px"
          class="corporateTransferDialog"
          :close-on-click-modal="false"
          :append-to-body="true">
        <div>
          <p>第一步 对公转账</p>
          <div class="corporateTransferDialog-info">
            <p>转账信息</p>
            <div class="flex">
              <p>收款人名称：</p>
              <p>{{ corporateTransferInfo.contacts }}</p>
            </div>
            <div class="flex">
              <p>收款人账号：</p>
              <p>{{ corporateTransferInfo.bank_account }}</p>
            </div>
            <div class="flex">
              <p>开户行名称：</p>
              <p>{{ corporateTransferInfo.sub_bank }}</p>
            </div>
            <div class="flex">
              <p>分行代码：</p>
              <p>{{ corporateTransferInfo.bank_code }}</p>
            </div>
            <div class="flex">
              <p>转账金额：</p>
              <div style="color: #FF4D4F">￥{{ Number((Number(orderAmount) * Number(buy_num)).toFixed(2)) }}</div>
<!--              <p >￥{{ orderAmount }}</p>-->
            </div>
            <button @click="handleCopy">复制转账信息</button>
          </div>
        </div>
        <div>
          <p>第二步 填写付款信息及上传付款回执</p>
          <el-form label-position="top" ref="corporateTransferForm_ref" :rules="corporateTransferFormRules" :model="corporateTransferForm"
                   @submit.native.prevent>
            <el-form-item label="付款方" prop="companyName">
              <el-input placeholder="请填写" v-model="corporateTransferForm.companyName"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="companyTel">
              <el-input placeholder="请填写" v-model.number="corporateTransferForm.companyTel"></el-input>
            </el-form-item>
            <el-form-item label="请上传付款回执" prop="paymentReceipt">
              <el-upload
                  class="avatar-uploader"
                  :action="$Url"
                  :headers="imageUploadheaders"
                  :show-file-list="false"
                  :on-success="handleImageUploadSuccess"
                  :on-error="handleImageUploadError"
                  accept=".jpg, .png, .jpeg, .pdf">
                <el-image v-if="corporateTransferForm.paymentReceipt" fit="contain"
                          :src="corporateTransferForm.paymentReceipt" class="avatar"></el-image>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <button class="corporateTransferDialog-submit" @click="submitTransferInfo">提交</button>
        </div>
      </el-dialog>
      <el-dialog
          title="请选择订单支付"
          :visible.sync="decision_show"
          width="400px"
          class="corporateTransferDialog"
          :close-on-click-modal="false"
          :append-to-body="true">
        <div>

        </div>
        <div slot="footer" class="footer">
          <button class="btn next_btn next" @click="Gopay">支付上一笔</button>
          <button class="btn next_btn next" @click="continues">重新下单</button>
        </div>
      </el-dialog>
      <el-dialog
          title="新建抬头"
          :visible.sync="new_header_show"
          width="800px"
          :close-on-click-modal="false"
          :append-to-body="true"
      >
        <el-form
            :model="headerForm"
            :rules="header_rules"
            ref="headerFormRef"
            label-position="top"
        >
          <el-row :gutter="24">
            <el-col :xl="8" :lg="8">
              <el-form-item label="发票类型" prop="invoice_type">
                <el-select
                    class="form_item"
                    disabled
                    v-model="headerForm.invoice_type"
                    placeholder="请选择发票类型"
                >
                  <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="8" :lg="8">
              <el-form-item label="抬头类型" prop="header_type">
                <el-select
                    class="form_item"
                    v-model="headerForm.header_type"
                    placeholder="请选择抬头类型"
                >
                  <el-option
                      v-for="item in headerOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="8" :lg="8">
              <el-form-item label="发票抬头名称" prop="header">
                <el-input
                    v-model="headerForm.header"
                    placeholder="请填写"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="8" :lg="8" v-if="headerForm.header_type == 1">
              <el-form-item label="纳税人识别号" prop="identification_code">
                <el-input
                    v-model="headerForm.identification_code"
                    placeholder="请填写"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="8" :lg="8">
              <el-form-item label="邮箱" prop="email">
                <el-input
                    v-model="headerForm.email"
                    placeholder="请填写"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="new_header_show = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('headerFormRef')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import {
  placeAnorder,
  getPaymentMethod,
  setPrePaidOrder,
  getCorporateTransferInfo,
  MembersDetail,
  getMemberLevelDetail,
  getUnifiedOrderPayStatus, invoiceHeaderLists, Order_applyInvoic, invoiceHeaderDetail, invoiceHeaderAdd
} from '../api/api'

export default {
  name: "attestation",
  props: ['payment_title'],
  data() {
    return {
      headerForm: {
        invoice_type: 3
      },
      headerForm_web: {},
      applyFor_form: {},
      applyFor_form_rules: {
        invoice_id: [{required: true, message: '请选择', trigger: ['blur', 'change']}],
      },

      header_rules: {
        invoice_type: [
          {required: true, message: "请选择发票类型", trigger: "change"},
        ],
        header_type: [
          {required: true, message: "请选择抬头类型", trigger: "change"},
        ],
        header: [{required: true, message: "请填写发票抬头名称", trigger: "blur"}],
        identification_code: [{required: true, message: "请填写纳税人识别号", trigger: "blur"}],
        email: [
          {required: true, message: "请填写", trigger: "blur"},
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      invoiceList: [],
      type: JSON.parse(localStorage.getItem("userdata")).type,
      headerOptions: [
        {
          label: "企业单位",
          value: 1,
        },
        {
          label: "个人/非企业单位",
          value: 2,
        },
      ],
      typeOptions: [
        {
          label: "全国性社会团体会费统一票据",
          value: 3,
        },
        {
          label: "普通发票",
          value: 1,
        },
        {
          label: "专用发票",
          value: 2,
        },
      ],

      buy_num: 1,
      member_payment_years: JSON.parse(window.localStorage.getItem('dictdata')).member_payment_years,
      payment_notice: '您的资料已经通过审核，请支付会员费用；支付成功后您将成为正式会员',
      decision_show: false,
      new_header_show: false,
      // 页面显示
      paymentLoading: false,
      QRCodeLoading: false,
      showPaymentOnline: false,
      showCorporateTransfer: false,
      // 页面
      longId: '',
      orderAmount: '',
      orderName: '',
      // 在线支付
      payMethod: -1,
      orderNumber: '',
      createOrderTime: '',
      QRCodeSrc: '',
      paymentInfo: [],
      aliPayForm: '',
      // 对公转账
      corporateTransferInfo: {},
      corporateTransferForm: {
        companyName: '',
        companyTel: '',
        paymentReceipt: '',
        halfPaymentReceipt: '',
      },
      corporateTransferFormRules: {
        paymentReceipt: [
          {
            required: true,
            message: '请上传付款回执',
            trigger: 'blur'
          },
        ],
        // companyName: [
        //   {
        //     required: true,
        //     message: '请输入企业全称',
        //     trigger: 'blur'
        //   },
        // ],
        // companyTel: [
        //   {
        //     required: true,
        //     message: '请输入联系电话',
        //     trigger: 'blur'
        //   },
        //   {
        //     pattern: /^[0-9]{11}$/,
        //     message: '电话号码必须是数字且长度为11位',
        //     trigger: 'blur'
        //   }
        // ]
      },
      imageUploadheaders: {
        token: localStorage.getItem("token")
      },
    };
  },

  async created() {
    const data = `type=${this.type}`;
    const res = await MembersDetail(data);
    if (res.code == 1) {
      this.longId = res.data.level_long_id;

      const res2 = await getMemberLevelDetail(`level_long_id=${this.longId}`);
      this.orderAmount = res2.data.cfee;
      this.orderName = '会员费用'
      // this.orderName = res2.data.level_name;
    }
    if (this.payment_title) {
      this.payment_notice = this.payment_title
    }
    this.getInvoiceList()
  },
  methods: {
    timer() {
      if(this.showPaymentOnline == false){
        return
      }
      setTimeout(async () => {
        const res = await getUnifiedOrderPayStatus(`sn=${this.orderNumber}`);
        if (res.data.pay_status == '已支付') {
          this.$message.success('订单已支付成功');
          this.showPaymentOnline = false
          setTimeout(() => {
            window.location.reload()
          }, 1000);
        } else {
          this.timer();
        }
      }, 2000);
    },
    async getInvoiceList() {
      let data = this.$qs.stringify({
        type: this.type,
        page_no: 1,
        page_size: 30,
      });
      const res = await invoiceHeaderLists(data)
      this.invoiceList = res.data.lists;
    },
    applyForSubmit() {
      this.$refs['applyFor_form_ref'].validate((valid) => {
            if (valid) {
              this.applyFor_form.sn=this.orderNumber
              console.log(this.applyFor_form)
              Order_applyInvoic(this.applyFor_form)
                  .then((res) => {
                    if (res.code == 1) {
                      this.$message.success(res.msg);
                    }
                  })
                  .catch((err) => {
                    if (err.response.code != 401) {
                      this.$message.warning(err.response);
                    }
                  });
            }
      })
    },
    toAdd() {
     this.headerForm={
        invoice_type: 3
      }
      this.new_header_show = true
    },
    // invoiceChange(id){
    //  this.getDetail(id)
    // },
    invoiceChange(id) {
      this.loading = true;
      invoiceHeaderDetail(this.$qs.stringify({id: id, type: this.type}))
          .then((res) => {
            this.loading = false;
            if (res.code == 1) {
              this.headerForm_web = res.data;
            } else {
              this.$message.warning(res.data.message);
            }
          })
          .catch((err) => {
            this.loading = false;
          });
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitInfo();
        } else {
          return false;
        }
      });
    },
    //提交
    async submitInfo() {
      let data = this.headerForm;
      data.mark = this.mark;
      data.type = this.type;
      const res = await invoiceHeaderAdd(data)
      if (res.code == 1) {
        this.new_header_show = false
        this.getInvoiceList()
        this.$message.success("添加成功！");
      } else {
        this.$message.warning(res.data.message);
      }
    },
    reverse_display(value,arr){
      if(value){
        let mm={}
        arr.forEach(item => {
         if(item.value == value){
           mm=item
         }
        })
        return mm.label
      }
    },
    // 展示支付dialog并生成订单号
    async handleShowPaymentOnline() {
          this.$refs['applyFor_form_ref'].validate(async (valid) => {
            if(valid) {
              let data = {
                client_type: `member_type${this.type}`,
                level_long_id: this.longId,
                buy_num: this.buy_num,
                invoice_id: this.applyFor_form.invoice_id
              }
              const res = await placeAnorder(data);
              this.orderNumber = res.data.sn;
              this.createOrderTime = res.data.order_time
              if (this.orderAmount != 0) {
                if (res.code == 2001) {
                  this.decision_show = true
                } else {
                  this.decision_show = false;
                  this.showPaymentOnline = true;
                  this.timer()
                  this.paymentLoading = true;
                  this.getPayMethod()
                }
              } else {
                console.log(this.paymentInfo)
                const data1 = {
                  pay_way: 1,
                  sn: this.orderNumber,
                  terminal: 4,
                  client_type: `member_type${this.type}`,
                }
                this.orderNumber
                const res1 = await setPrePaidOrder(data1);
                if (res1.code == 1 && res1.data.payment_status == 'success') {
                  this.handlePaidAlready()
                } else {
                  this.$message.warning('支付失败，请联系工作人员');
                }
              }
            }
          })
    },
    // 支付上一笔
    Gopay() {
      this.decision_show = false
      this.$router.push({
        path: '/recruit'
      });
    },
    async continues() {
      let data = {
        client_type: `member_type${this.type}`,
        level_long_id: this.longId,
        buy_num: this.buy_num,
        again_place: 1,
        invoice_id: this.applyFor_form.invoice_id
      }
      const res = await placeAnorder(data);
      this.orderNumber = res.data.sn;
      this.createOrderTime = res.data.order_time
      this.decision_show = false;
      this.showPaymentOnline = true;
      this.paymentLoading = true;
      this.timer()
      this.getPayMethod()

    },
    // 获取支付方式
    async getPayMethod() {
      let type = Number(this.type);
      const res = await getPaymentMethod(`scene=${type + 1}`);
      this.paymentInfo = res.data.slice(0, 2); // 只拿前两项微信支付和支付宝支付
      this.paymentInfo.forEach(item => {
        item.pay_way_name = this.cutBeforeChar(item.pay_way_name, '（');
      })
      this.paymentLoading = false;
    },
    // 截取字符串中某个字符之前的所有字符
    cutBeforeChar(str, char) {
      const index = str.indexOf(char);
      if (index === -1) {
        return str;
      }
      return str.substring(0, index);
    },
    change_buy_num(item) {
      this.buy_num = item.value
    },
    // 选择支付方式后，预支付并获取微信、支付宝二维码
    async handleSelectPayMethod(flag) {
      if (flag === this.payMethod) {
        return false;
      }
      this.QRCodeLoading = true;
      this.payMethod = flag;
      const data = {
        pay_way: flag,
        sn: this.orderNumber,
        terminal: 4,
        client_type: `member_type${this.type}`,
      }
      const res = await setPrePaidOrder(data);
      if (res.data.pay_way === 2) {
        QRCode.toDataURL(res.data.data).then(url => {
          this.QRCodeSrc = url;
          this.QRCodeLoading = false;
        });
      } else if (res.data.pay_way === 3) {
        this.aliPayForm = res.data.data;
        setTimeout(() => {
          this.QRCodeLoading = false;
        }, 1000)
      }

    },
    // 展示对公转账dialog并获取对公转账信息
    async handleShowCorporateTransfer() {
      this.payMethod = -1;
      setTimeout(() => {
        this.showPaymentOnline = false;
      }, 10)
      this.showCorporateTransfer = true;
      const res = await getCorporateTransferInfo(`client_type=member_type${this.type}`);
      this.corporateTransferInfo = res.data
    },
    // 点击我已缴费
    async handlePaidAlready() {
      const res = await getUnifiedOrderPayStatus(`sn=${this.orderNumber}`);
      if (res.data.pay_status == '已支付') {
        this.$message.success('订单已支付成功');
        this.showPaymentOnline = false
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      } else {
        this.$message.warning('订单状态' + res.data.pay_status);
      }

    },
    // 一键复制
    handleCopy() {
      let data = this.corporateTransferInfo;
      let text = `收款人名称：${data.contacts}\n收款人账号：${data.bank_account}\n开户行名称：${data.sub_bank}\n分行代码：${data.bank_code}\n转账金额：￥${this.orderAmount}`
      navigator.clipboard.writeText(text)
          .then(() => {
            this.$message.success('复制成功');
          })
          .catch(() => {
            this.$message.warning('复制失败');
          })
    },
    // 上传图片成功
    handleImageUploadSuccess(res, file, fileList) {
      this.$message.success('上传成功！')
      this.corporateTransferForm.paymentReceipt = res.data.uri;
      this.corporateTransferForm.halfPaymentReceipt = res.data.url;
    },
    // 上传图片失败
    handleImageUploadError() {
      this.$message.error('上传失败，请稍后再试！');
    },
    // 对公转账的预支付
     submitTransferInfo() {
      let that=this
      this.$refs['corporateTransferForm_ref'].validate(async (valid) => {
        if (valid) {
          const companyName = this.corporateTransferForm.companyName;
          const companyTel = String(this.corporateTransferForm.companyTel);
          // if (companyName.trim() === '') {
          //   this.$message.error('企业全称不能为空！');
          //   return false;
          // } else if (companyTel.trim() === '' || companyTel.trim().length !== 11) {
          //   this.$message.error('联系电话不能为空且必须为11位');
          //   return false;
          // }
          const data = {
            pay_way: 4,
            sn: this.orderNumber,
            terminal: 4,
            client_type: `member_type${this.type}`,
            pay_voucher: this.corporateTransferForm.halfPaymentReceipt,
            payment_company: companyName,
            payment_mobile: companyTel
          }
          const res = await setPrePaidOrder(data);
          if (res.code == 1) {
            this.$alert('您已成功提交缴费凭证，请等待确认订单，无需再次操作。', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.go_back()
              }
            });
            // this.$message.success(res.data.data);
            this.showCorporateTransfer = false;
            this.showPaymentOnline = false;
          }
        }
      })

    },
    go_back(){
      this.$router.go(-1);
    }
  },
};

</script>
<style lang="scss" scoped>

.flex {
  display: flex;
}
.box_right{
  margin-left: 100px;
  >div{
    margin-bottom: 10px;
  }
}
.main1 {
  overflow: hidden;
  background: #FFF;
  margin-top: 20px;
}

.content1 {
  font-family: PingFangSC, PingFang SC;
  font-size: 14px;
  color: #1D1D1D;
  margin: 0;
  width: 100%;
  border-radius: 0;
  height: auto;
  background-color: #FFF;;

  .payment {
    border-bottom: 1px solid #EEE;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .payment-information {
    margin-top: 18px;

    > p {
      font-weight: 500;
      margin-right: 10px;
    }

    > div {
      color: #555;

      div {
        margin-bottom: 8px;
      }

      div:last-child {
        margin-bottom: 0;
      }
    }
  }

  .payment-price {
    align-items: center;
    margin-top: 18px;

    p {
      font-weight: 500;
      margin-right: 10px;
    }

    div {
      color: #FF4D4F;
      font-size: 18px;
      font-weight: 700;
    }
  }

  .pay {
    width: 128px;
    height: 36px;
    background: linear-gradient(90deg, #F27FC0 0%, #E40080 100%);
    border: none;
    color: #fff;
    font-size: 14px;
    border-radius: 8px;
    cursor: pointer;
  }
}

.payment-dialog .el-dialog__body {
  p {
    font-weight: 500;
    color: #1D1D1D;
    margin-bottom: 10px;
  }

  .paymentOnlineDialog-infomation {
    width: 100%;
    background-color: #F7F9FA;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;

    .flex:last-child p {
      margin-bottom: 0;
    }

    p {
      color: #555;
    }
  }
.invoice_box{
  background: #ffffff;
  margin-top: 20px;
  border-radius: 5px;
  padding: 15px;
}

  .paymentOnlineDialog-method {
    height: 120px;

    .left {
      padding-right: 80px;
      border-right: 1px solid #EEE;

      .paymentOnlinceDialog-QRCode {
        width: 120px;
        height: 120px;
        margin-right: 15px;

        > span {
          width: 100%;
          height: 100%;
        }

        > img {
          width: 100%;
          height: 100%;
        }

        > iframe {
          width: 100%;
          height: 100%;
        }
      }

      .parmentOnlineDialog-title {
        margin-top: 10px;
      }

      .paymentOnlineDialog-channel {
        width: 98px;
        height: 36px;
        box-sizing: border-box;
        border: 1px solid #EEE;
        margin-right: 10px;
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
          margin-left: 9px;
          margin-top: 8px;
        }

        div {
          font-size: 12px;
          color: #000;
          line-height: 36px;
          margin-left: 3px;
        }
      }

      .paymentOnlineDialog-channel.selected {
        border-color: #E40080;
      }

      .paymentOnlineDialog-channel:hover {
        border-color: #E40080;
      }

      .paymentOnlineDialog-paidAlready {
        margin-top: 10px;
        border: 1px solid #eee;
        width: 253px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #fff;
        font-size: 14px;
        cursor: pointer;
      }

      .paymentOnlineDialog-paidAlready:hover {
        border-color: #E40080;
      }
    }

    .right {
      padding-left: 64px;

      > .flex {
        align-items: center;
        margin-top: 10px;

        .paymentOnlineDialog-icon {
          width: 20px;
          height: 20px;
          background-color: #FA7214;
          line-height: 20px;
          text-align: center;
          color: #fff;
          border-radius: 50%;
          font-weight: 700;
          font-size: 20px;
        }

        p {
          margin: 0;
          margin-left: 5px;
        }
      }

      .paymentOnlineDialog-tips {
        width: 228px;
        font-size: 12px;
        color: #555;
        margin-left: 25px;
        line-height: 17px;
        margin-top: 5px;
      }

      button {
        width: 253px;
        height: 36px;
        background: #fff;
        border: 1px solid #eee;
        font-size: 12px;
        margin-top: 10px;
        cursor: pointer;
      }

      button:hover {
        border-color: #E40080;
      }
    }
  }
}

.corporateTransferDialog {
  /deep/ .el-dialog__body {
    display: flex;

    > div {
      width: 50%;

      p {
        font-size: 14px;
        color: #1D1D1D;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .corporateTransferDialog-info {
        padding: 20px;
        background-color: #F7F9FA;

        .flex {
          margin-bottom: 20px;

          p {
            color: #555;
            margin-bottom: 0
          }
        }

        .flex:nth-child(6) {
          margin-bottom: 0;
        }

        button {
          margin: 0;
          width: 108px;
          height: 36px;
          background-color: #fff;
          color: #333;
          font-size: 12px;
          border-radius: 8px;
          border: 1px solid #CAD2DD;
          cursor: pointer;
          margin-top: 70px;
        }

        button:hover {
          border-color: #E40080;
        }
      }

      .corporateTransferDialog-submit {
        height: 36px;
        width: 128px;
        border: none;
        background: linear-gradient(90deg, #F27FC0 0%, #E40080 100%);
        text-align: center;
        line-height: 36px;
        border-radius: 8px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        margin-top: 8px;
        float: right;
      }
    }

    > div:first-child {
      padding-right: 40px;
      box-sizing: border-box;
    }
  }
}

.card_box {
  display: flex;
  padding: 20px 0;
  margin-bottom: 20px;
  border-bottom: 1px solid #EEE;
}

.card {
  width: 140px;
  height: 88px;
  background: #F7F9FA;
  border-radius: 8px;
  display: flex;
  position: relative;
  margin-right: 20px;
  cursor: pointer;
}

.cardSelected {
  cursor: pointer;
  width: 140px;
  height: 88px;
  background: rgba(228, 0, 128, 0.02);
  border-radius: 8px;
  border: 2px solid #E40080;
  margin-right: 20px;

  display: flex;
  position: relative
}

/deep/ .el-dialog {
  border-radius: 8px;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .el-dialog__header {
  padding: 0;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

/deep/ .el-form-item__label {
  font-size: 14px;
  color: #555;
  height: 20px;
  line-height: 20px;
  margin-bottom: 5px;
}

/deep/ .el-input {
  border-radius: 8px;
  height: 36px;
}

/deep/ .el-input .el-input__inner:hover {
  border-color: #E40080;
}

/deep/ .el-form-item {
  margin-bottom: 20px;
}

///deep/ .el-form-item__label::after {
//  content: '*';
//  color: #FF4D4F;
//  margin-left: 2px;
//}

/deep/ .el-icon-close:hover {
  color: #E40080;
}

/deep/ .el-icon-loading {
  color: #E40080;
}

/deep/ .el-loading-text {
  color: #E40080;
}

.avatar-uploader {
  width: 220px;
  height: 130px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
  margin: 0;
}
.payment-notice{
  margin: 10px 0;
}
.avatar {
  width: 220px;
  height: 130px;
  display: block;
  border-radius: 8px;
}

.footer {
  display: flex;
  justify-content: space-around;
}

/deep/ .el-dialog__header {
  text-align: center !important;
  margin: 20px;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .el-dialog {
  padding: 20px !important;
}
</style>



